var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9173 7.16634C17.1813 7.16634 7.66732 16.6803 7.66732 28.4163C7.66732 40.1524 17.1813 49.6663 28.9173 49.6663C40.6534 49.6663 50.1673 40.1524 50.1673 28.4163C50.1673 16.6803 40.6534 7.16634 28.9173 7.16634ZM0.583984 28.4163C0.583984 12.7683 13.2693 0.0830078 28.9173 0.0830078C44.5654 0.0830078 57.2507 12.7683 57.2507 28.4163C57.2507 34.9639 55.0297 40.9927 51.3001 45.7905L70.38 64.8703C71.7631 66.2534 71.7631 68.4959 70.38 69.879C68.9969 71.2621 66.7544 71.2621 65.3713 69.879L46.2915 50.7992C41.4936 54.5288 35.4648 56.7497 28.9173 56.7497C13.2693 56.7497 0.583984 44.0644 0.583984 28.4163Z",
    fill: "#F8FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3aab302d6b5a7b59899e164737f1abb1.svg";
export { ForwardRef as ReactComponent };